"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MegaphoneOutline_exports = {};
__export(MegaphoneOutline_exports, {
  default: () => MegaphoneOutline_default
});
module.exports = __toCommonJS(MegaphoneOutline_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.79688 3.60938C9.95312 3.25781 10.2135 3.01693 10.5781 2.88672C10.9427 2.75651 11.3008 2.76953 11.6523 2.92578C11.7695 2.97786 11.8737 3.04297 11.9648 3.12109C12.069 3.19922 12.1536 3.28385 12.2188 3.375L12.2969 3.49219L16.9258 11.3438C17.1211 11.6693 17.1667 12.0143 17.0625 12.3789C16.9583 12.7435 16.737 13.0234 16.3984 13.2188C16.3203 13.2708 16.2357 13.3099 16.1445 13.3359C16.0534 13.362 15.9557 13.3815 15.8516 13.3945L15.7148 13.4141L11.2812 13.4336C11.0208 13.4336 10.7604 13.4596 10.5 13.5117C10.2526 13.5638 10.0117 13.6354 9.77734 13.7266L10.7539 16.0312C10.8711 16.3307 10.8841 16.6367 10.793 16.9492C10.7018 17.2487 10.5195 17.4961 10.2461 17.6914L10.1484 17.75L8.99609 18.3945C8.65755 18.5898 8.29948 18.6419 7.92188 18.5508C7.55729 18.4466 7.27734 18.2253 7.08203 17.8867L7.02344 17.8086L7.00391 17.7305L6.125 15.6992C5.85156 15.7643 5.57812 15.7513 5.30469 15.6602C5.03125 15.556 4.81641 15.3867 4.66016 15.1523L4.58203 15.0547L3.19531 12.6719C3.01302 12.3724 2.96094 12.0469 3.03906 11.6953C3.11719 11.3438 3.29948 11.0703 3.58594 10.875L3.70312 10.7969L6.35938 9.29297C6.67188 9.1237 6.95182 8.90885 7.19922 8.64844C7.45964 8.38802 7.67448 8.10156 7.84375 7.78906L7.94141 7.59375L9.79688 3.60938ZM8.80078 14.8008L7.49219 15.543L8.21484 17.2422L8.23438 17.2812C8.2474 17.2812 8.26042 17.2878 8.27344 17.3008C8.28646 17.3008 8.29948 17.3008 8.3125 17.3008L8.35156 17.2812L9.50391 16.6367C9.51693 16.6237 9.52344 16.6107 9.52344 16.5977C9.53646 16.5846 9.54297 16.5716 9.54297 16.5586V16.5195L8.80078 14.8008ZM7.39453 10.1719L7.19922 10.2891L7.00391 10.4062L4.36719 11.9102C4.34115 11.9232 4.32161 11.9362 4.30859 11.9492C4.30859 11.9622 4.30859 11.9818 4.30859 12.0078L4.32812 12.0469L5.71484 14.4102C5.72786 14.4232 5.74089 14.4362 5.75391 14.4492C5.77995 14.4492 5.79948 14.4492 5.8125 14.4492L5.85156 14.4297L8.72266 12.8086C8.7487 12.7956 8.77474 12.7826 8.80078 12.7695C8.83984 12.7565 8.8724 12.737 8.89844 12.7109L7.39453 10.1719ZM11.0664 4.07812C11.0534 4.07812 11.0404 4.08464 11.0273 4.09766C11.0273 4.09766 11.0208 4.09766 11.0078 4.09766L10.9883 4.13672L9.13281 8.12109C9.02865 8.32943 8.91146 8.53125 8.78125 8.72656C8.66406 8.92188 8.53385 9.11068 8.39062 9.29297L10.1484 12.2617C10.2786 12.2357 10.4154 12.2161 10.5586 12.2031C10.7018 12.1771 10.8451 12.1576 10.9883 12.1445H11.2812L15.6953 12.125C15.7083 12.125 15.7148 12.125 15.7148 12.125C15.7279 12.125 15.7409 12.1185 15.7539 12.1055C15.7669 12.0924 15.7734 12.0794 15.7734 12.0664C15.7865 12.0534 15.793 12.0339 15.793 12.0078V11.9883L11.1445 4.13672L11.125 4.09766H11.1055L11.0664 4.07812ZM16.2227 8.49219C16.2617 8.36198 16.3398 8.25781 16.457 8.17969C16.5742 8.10156 16.7044 8.07552 16.8477 8.10156L16.9258 8.12109L18.4102 8.53125L18.5078 8.55078C18.625 8.61589 18.7161 8.71354 18.7812 8.84375C18.8464 8.96094 18.8594 9.08464 18.8203 9.21484C18.7812 9.35807 18.6966 9.46875 18.5664 9.54688C18.4492 9.61198 18.3255 9.63802 18.1953 9.625L18.0977 9.60547L16.6133 9.19531L16.5352 9.15625C16.4049 9.10417 16.3073 9.01953 16.2422 8.90234C16.1901 8.77214 16.1836 8.63542 16.2227 8.49219ZM17.8438 5.60156C17.9089 5.73177 17.9284 5.86849 17.9023 6.01172C17.8763 6.14193 17.8047 6.24609 17.6875 6.32422L17.6289 6.38281L15.9883 7.30078C15.8451 7.37891 15.6953 7.39844 15.5391 7.35938C15.3958 7.32031 15.2786 7.23568 15.1875 7.10547C15.1224 6.97526 15.1029 6.84505 15.1289 6.71484C15.1549 6.57161 15.2266 6.46094 15.3438 6.38281L15.4023 6.34375L17.0625 5.40625C17.1927 5.32812 17.3359 5.30859 17.4922 5.34766C17.6484 5.38672 17.7656 5.47135 17.8438 5.60156ZM15.0898 2.76953C15.2331 2.80859 15.3438 2.88672 15.4219 3.00391C15.5 3.10807 15.5326 3.23177 15.5195 3.375L15.5 3.45312L15.0703 4.97656C15.0312 5.13281 14.9401 5.25 14.7969 5.32812C14.6667 5.39323 14.5234 5.40625 14.3672 5.36719C14.237 5.34115 14.1328 5.26953 14.0547 5.15234C13.9766 5.03516 13.944 4.91146 13.957 4.78125L13.9766 4.68359L14.3867 3.16016C14.4258 3.01693 14.5169 2.90625 14.6602 2.82812C14.8034 2.75 14.9466 2.73047 15.0898 2.76953Z",
      fill: "currentColor"
    }
  )
);
const SvgMegaphoneOutline = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var MegaphoneOutline_default = SvgMegaphoneOutline;
